import { render, staticRenderFns } from "./ZakatCalculator.vue?vue&type=template&id=2482c971"
import script from "./ZakatCalculator.vue?vue&type=script&lang=js"
export * from "./ZakatCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports